import { useState } from "react";
import api from "../../services/api";

export default function LoginApp() {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setErro("");
    setLoading(true);

    try {
      const { data } = await api.post("/login.php", {
        email,
        senha,
      });

      if (!data.token) {
        throw new Error("Token não retornado");
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("role", data.role);

      if (data.role === "admin") {
        window.location.href = "/app/admin/dashboard";
      } else {
        window.location.href = "/app/cliente/processos";
      }

    } catch (err) {
      console.error("Erro login:", err);

      if (err.response?.status === 401) {
        setErro("Email ou senha inválidos");
      } else {
        setErro("Erro ao conectar com o servidor");
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-[#0b0f19] flex items-center justify-center">
      <form
        onSubmit={handleLogin}
        className="w-full max-w-sm rounded-2xl border border-[#1f2937] bg-[#121826] p-6"
      >
        <h1 className="text-xl font-semibold text-slate-100">
          Acesso ao Sistema
        </h1>
        <p className="mt-1 text-sm text-slate-400">
          Área restrita
        </p>

        {erro && (
          <p className="mt-4 text-sm text-red-400">{erro}</p>
        )}

        <div className="mt-6 space-y-4">
          <input
            type="email"
            placeholder="Email"
            className="w-full rounded-xl border border-[#1f2937] bg-[#0b0f19] px-4 py-3 text-slate-100"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Senha"
            className="w-full rounded-xl border border-[#1f2937] bg-[#0b0f19] px-4 py-3 text-slate-100"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            required
          />

          <a
            href="/app/esqueci-senha"
            className="text-xs text-slate-400 hover:text-slate-200"
          >
            Esqueci minha senha
          </a>
        </div>

        <button
          disabled={loading}
          className="mt-6 w-full rounded-xl bg-blue-600 py-3 text-sm font-semibold hover:bg-blue-500 disabled:opacity-60"
        >
          {loading ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}
